<p-dialog
  header="Was ist der Sicherheitscode?"
  i18n-header="@@payment_method.label.what_is_a_security_code"
  [visible]="visible$ | async"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [closable]="false"
>
  <p i18n="@@payment_method.label.description_of_cvc_code"
    >Ein dreistelliger Code befindet sich auf der Rückseite Ihrer Kreditkarte.
    <br />
    Bei American Express-Karten ist der vierstellige Code auf der Vorderseite
    neben der Kartennummer.
  </p>
  <div class="d-flex align-items-end">
    <img
      [src]="
        'orderform-widgets/images/creditcard_cvc_other.png' | orderformAsset
      "
      alt="cvc other credit cards"
    />

    <img
      [src]="'orderform-widgets/images/creditcard_cvc_am.png' | orderformAsset"
      alt="cvc american express"
    />
  </div>

  <p-footer>
    <button
      class="ds-button primary"
      (click)="close()"
      i18n="@@common.button.close"
      >Schließen</button
    >
  </p-footer>
</p-dialog>
